import React from "react";
import { Crosshair, Hammer, Flame, Users, Award, Zap } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const values = [
  { icon: Crosshair, name: "Strategic", desc: "Every decision earns its place. We pick the right fight, then we win it." },
  { icon: Zap, name: "Innovative", desc: "We chase the ideas that other teams dismiss — then we ship them." },
  { icon: Flame, name: "Creative", desc: "Craft over cleverness. Form that serves the work, not the ego." },
  { icon: Users, name: "Collaborative", desc: "Your team plus ours, one standard. No silos, no hand-offs that break." },
  { icon: Hammer, name: "Customer-Focused", desc: "We build for the person holding the phone, not the spec doc." },
  { icon: Award, name: "Quality-Driven", desc: "If it's not worth shipping right, it's not worth shipping." },
];

function CoreValues() {
  return (
    <section id="values" className="section relative bg-levi-bg">
      <div className="container-xl">
        <Reveal className="text-center max-w-2xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-levi-primary" />
            <span className="eyebrow">Core Values</span>
            <span className="h-px w-12 bg-levi-primary" />
          </div>
          <h2 className="display-lg text-levi-text">
            The code <br />
            <span className="text-levi-primary">we live by.</span>
          </h2>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map(({ icon: Icon, name, desc }) => (
            <StaggerItem key={name}>
              <div className="group relative h-full p-8 bg-levi-surface border border-levi-border hover:border-levi-primary transition-all duration-500 cursor-default">
                <div className="absolute top-0 left-0 h-1 w-0 bg-levi-primary group-hover:w-full transition-all duration-500" />
                <div className="flex items-center gap-4 mb-5">
                  <div className="p-3 border border-levi-border group-hover:border-levi-primary group-hover:text-levi-primary text-levi-text transition-colors duration-500">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-display text-2xl tracking-widest uppercase text-levi-text">
                    {name}
                  </h3>
                </div>
                <p className="text-levi-muted leading-relaxed">{desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default CoreValues;
